import * as Yup from 'yup';

export const validationSchema = Yup.object({
  name: Yup.string().required('Campo obrigatório'),
  priority: Yup.number().typeError('Campo obrigatório').required(),
});
